export default __webpack_public_path__ + "static/media/webcam11.10c4afdd.jfif";